import { module } from 'modujs'

export default class extends module {

    constructor(m) {
        super(m);

        // Binding
        this.onMouseEnterBind = this.onMouseEnter.bind(this)
        this.onMouseLeaveBind = this.onMouseLeave.bind(this)

        // UI
        this.$tiles = this.$('tile')

        // Data
        this.currentUID = null
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$tiles.forEach($tile => {
            $tile.addEventListener("mouseenter", this.onMouseEnterBind)
            $tile.addEventListener("mouseleave", this.onMouseLeaveBind)
        });
    }

    unbindEvents() {
        this.$tiles.forEach($tile => {
            $tile.removeEventListener("mouseenter", this.onMouseEnterBind)
            $tile.removeEventListener("mouseleave", this.onMouseLeaveBind)
        });
    }

    ///////////////
    // Callbacks
    ///////////////
    target(args) {
        requestAnimationFrame(() => {
            if (args != null) {
                this.unactiveTile()
                this.currentUID = args
                const $tile = this.activeTile()

                // Scroll to the target tile
                if ($tile) {
                    this.el.scroll({
                        top: $tile.offsetTop,
                        behavior: 'smooth'
                    })
                }
            }
        })
    }

    onMouseEnter(e) {
        this.unactiveTile()
        this.currentUID = this.getData('uid', e.currentTarget)
        this.activeTile()
        this.call('activeMarker', this.currentUID, 'Gmap')
    }

    onMouseLeave() {
        this.unactiveTile()
        this.call('unactiveMarker', this.currentUID, 'Gmap')
    }

    /**
     * Used in Gmap.js module to call this from map interactions
     *
     * @param id
     */
    activateTileFromId(id) {
        this.currentUID = id;
        this.activeTile();
    }

    ///////////////
    // Methods
    ///////////////
    activeTile() {
        if (this.currentUID === null) return
        const $tile = [...this.$tiles].find(($tile) => this.currentUID === $tile.dataset.mapListUid)
        $tile.classList.add('is-active')
        return $tile
    }

    unactiveTile() {
        if (this.currentUID === null) return
        const $tile = [...this.$tiles].find(($tile) => this.currentUID === $tile.dataset.mapListUid)
        $tile.classList.remove('is-active')
    }
}
